import { useCallback, useEffect, useMemo } from "react";
import { Flex, Text, CloseButton, Center } from "@chakra-ui/react";

// Constants
import { BANNER_CTA, CLOSE_BANNER, VIEW_BANNER } from "constants/analytics";
import { trackEvent } from "@utils/firebase";

import { useStakeProvider } from "dapp-sdk";

type Props = {
  text: string;
  link: string;
  ctaText: string;
  closeBanner: () => void;
  isClosable?: boolean;
  type: string;
  isSafeModeActive: boolean;
};

const Banner = ({
  text,
  link,
  ctaText,
  isClosable = true,
  isSafeModeActive = false,
  type,
  closeBanner,
}: Props) => {
  const { firebaseEventsData } = useStakeProvider();

  const logEvent = useCallback(
    (event: string) => {
      trackEvent(event, {
        ...firebaseEventsData,
      });
    },
    [firebaseEventsData]
  );

  useEffect(() => {
    logEvent(VIEW_BANNER);
  }, []);

  const getBGForBanner = useMemo(() => {
    if (isSafeModeActive) {
      return "#FF4D4D";
    } else if (type === "info") {
      return "#2196F3";
    }
    return "primary";
  }, [isSafeModeActive, type]);

  return (
    <Flex
      w="100%"
      bg={getBGForBanner}
      color="#FFFFFF"
      _dark={{
        color: "#142528",
      }}
      fontWeight="600"
      alignItems="center"
      pos={{ base: "relative", lg: "fixed" }}
      top="0"
      zIndex={4}
    >
      <Center flexGrow={1} flexDir={{ base: "column", lg: "row" }} p="8px">
        <Text
          textAlign={{ base: "left", md: "center" }}
          fontSize={{ base: "12px", lg: "14px" }}
          lineHeight={{ base: "18px", lg: "20px" }}
        >
          <Text as="span">{text} </Text>
        </Text>
        {link && ctaText && (
          <Text
            as="a"
            href={link}
            target="_blank"
            rel="noreferrer"
            p="0.25rem"
            fontSize={{ base: "12px", lg: "14px" }}
            lineHeight={{ base: "18px", lg: "20px" }}
            color="white"
            textDecor="underline !important"
            cursor="pointer"
            onClick={() => logEvent(BANNER_CTA)}
          >
            {ctaText}
          </Text>
        )}
      </Center>

      {isClosable && (
        <CloseButton
          onClick={() => {
            logEvent(CLOSE_BANNER);
            closeBanner();
          }}
        />
      )}
    </Flex>
  );
};

export default Banner;
